/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestCreateAppUpdateInformation } from '../model/models';
import { AppPlatform } from '../model/models';
import { AppUpdateInformation } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface AppUpdateInformationServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestCreateAppUpdateInformation 
     */
    appUpdateInformationControllerCreate0(apiRequestCreateAppUpdateInformation: ApiRequestCreateAppUpdateInformation, extraHttpRequestParams?: any): Observable<AppUpdateInformation>;

    /**
     * 
     * 
     * @param apiRequestCreateAppUpdateInformation 
     */
    appUpdateInformationControllerCreate1(apiRequestCreateAppUpdateInformation: ApiRequestCreateAppUpdateInformation, extraHttpRequestParams?: any): Observable<AppUpdateInformation>;

    /**
     * 
     * 
     * @param platform 
     * @param appVersion 
     */
    appUpdateInformationControllerCurrentVersion0(platform: AppPlatform, appVersion: number, extraHttpRequestParams?: any): Observable<object>;

    /**
     * 
     * 
     * @param platform 
     * @param appVersion 
     */
    appUpdateInformationControllerCurrentVersion1(platform: AppPlatform, appVersion: number, extraHttpRequestParams?: any): Observable<object>;

}
